import { Membership, MembershipBillingFrequency } from '@spike/membership-model';

/**
 * Human-readable billing frequency for a membership.
 * Prefers the server-formatted `billingFrequencyLabel` (e.g. "Every 28 days");
 * falls back to a locally built label for unsaved form state.
 */
export const formatBillingFrequency = (
    membership: Pick<Membership, 'billingFrequency' | 'billingIntervalDays' | 'billingFrequencyLabel'>
): string => {
    if (membership.billingFrequencyLabel) {
        return membership.billingFrequencyLabel;
    }

    const frequency = (membership.billingFrequency ?? '').toLowerCase();

    if (frequency === '') {
        return '';
    }

    if (frequency === MembershipBillingFrequency.CUSTOM) {
        const days = membership.billingIntervalDays;
        return days && days > 0 ? `Every ${days} days` : 'Custom';
    }

    return frequency.charAt(0).toUpperCase() + frequency.slice(1);
};
